<template>
  <section class="premium-ceo-section">
    <div class="ceo-container">
      <div class="ceo-content-grid">
        <div class="ceo-image-column" data-aos="fade-right">
          <div class="image-wrapper">
            <div class="image-backdrop"></div>
            <img src="@/assets/ceo-hlc.jpeg" alt="Hoza Longfor, CEO" class="ceo-portrait">
            <div class="credential-badge">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
                <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
              </svg>
              <span>Certified Instructor</span>
            </div>
          </div>
        </div>

        <div class="ceo-text-column" data-aos="fade-left" data-aos-delay="200">
          <div class="intro-badge">
            <span class="badge-dot"></span>
            {{ $t('home-page.about-container.int') }}
          </div>
          
          <h2 class="ceo-heading">
            {{ $t('home-page.about-container.name') }}
            <span class="name-highlight">Hoza Longfor</span>
          </h2>
          
          <p class="ceo-subtitle">{{ $t('home-page.about-container.subtitle') }}</p>
          
          <div class="ceo-description">
            <p class="bio-text">
              Bilingual (English/French) consultant with <strong>20+ years</strong> in transport, fleet operations, and international logistics across Africa. Founder & CEO of <strong>STE Hoza Logistique Conseil SARL</strong> and developer of the <strong>HABITSAFE Defensive Driving Framework</strong>.
            </p>
            <p class="bio-text">
              Certified <strong>Smith System Defensive Driving Instructor</strong> with a track record of reducing crash rates, strengthening compliance, and leading multi-stakeholder road safety programs. Expert in designing and delivering evidence-based, culturally adapted training aligned to the Safe System approach.
            </p>
          </div>

          <div class="expertise-section">
            <h3 class="expertise-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              Key Areas of Expertise
            </h3>
            <ul class="expertise-list">
              <li>
                <span class="bullet-icon">→</span>
                <span>Road Safety Training & Defensive Driving (Smith System)</span>
              </li>
              <li>
                <span class="bullet-icon">→</span>
                <span>Safety Systems & Regulatory Compliance</span>
              </li>
              <li>
                <span class="bullet-icon">→</span>
                <span>Stakeholder Engagement, Policy Advocacy & Government Liaison</span>
              </li>
              <li>
                <span class="bullet-icon">→</span>
                <span>Program Design, Facilitation & Evaluation (LMIC contexts)</span>
              </li>
              <li>
                <span class="bullet-icon">→</span>
                <span>Fleet Operations, Telematics & KPI-led Performance Management</span>
              </li>
              <li>
                <span class="bullet-icon">→</span>
                <span>Data-Driven Risk Assessment & Crash Reduction</span>
              </li>
              <li>
                <span class="bullet-icon">→</span>
                <span>Bilingual Training Delivery (EN/FR)</span>
              </li>
            </ul>
          </div>

          <div class="cta-section">
            <router-link to="/contact" class="btn-primary">
              <span>{{ $t('home-page.about-container.contact-us') }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </router-link>
            <a href="https://www.linkedin.com/in/ste-hoza-logistique-conseil-1087a0322" target="_blank" class="btn-linkedin" aria-label="LinkedIn Profile">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
              <span>Connect on LinkedIn</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.premium-ceo-section {
  background: linear-gradient(135deg, #0a1628 0%, #0f2744 50%, #1a3a5c 100%);
  padding: 6rem 2rem;
  position: relative;
  overflow: hidden;
}

.premium-ceo-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 50%, rgba(252, 188, 13, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 80%, rgba(59, 130, 246, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

.ceo-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.ceo-content-grid {
  display: grid;
  grid-template-columns: 400px 1fr;
  gap: 4rem;
  align-items: start;
}

/* Image Column */
.ceo-image-column {
  position: relative;
}

.image-wrapper {
  position: relative;
  border-radius: 20px;
  overflow: visible;
}

.image-backdrop {
  position: absolute;
  top: 20px;
  left: 20px;
  right: -20px;
  bottom: -20px;
  background: linear-gradient(135deg, #fcbc0d 0%, #f59e0b 100%);
  border-radius: 20px;
  z-index: 0;
  opacity: 0.3;
}

.ceo-portrait {
  width: 100%;
  height: auto;
  border-radius: 20px;
  display: block;
  position: relative;
  z-index: 1;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  border: 3px solid rgba(255, 255, 255, 0.1);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.ceo-portrait:hover {
  transform: translateY(-8px);
}

.credential-badge {
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #fcbc0d 0%, #f59e0b 100%);
  color: #0a1628;
  padding: 12px 24px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 0.875rem;
  box-shadow: 0 10px 30px rgba(252, 188, 13, 0.4);
  z-index: 2;
  letter-spacing: 0.5px;
}

/* Content Column */
.ceo-text-column {
  color: white;
}

.intro-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(252, 188, 13, 0.15);
  border: 1px solid rgba(252, 188, 13, 0.3);
  color: #fcbc0d;
  padding: 8px 20px;
  border-radius: 50px;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 1.5rem;
}

.badge-dot {
  width: 8px;
  height: 8px;
  background: #fcbc0d;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.ceo-heading {
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.2;
  margin: 0 0 1rem 0;
  color: white;
}

.name-highlight {
  display: block;
  background: linear-gradient(135deg, #fcbc0d 0%, #f59e0b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-top: 0.5rem;
}

.ceo-subtitle {
  font-size: 1.25rem;
  color: #94a3b8;
  font-weight: 500;
  margin: 0 0 2rem 0;
  line-height: 1.6;
}

.ceo-description {
  margin-bottom: 2.5rem;
}

.bio-text {
  color: #cbd5e1;
  line-height: 1.8;
  font-size: 1rem;
  margin-bottom: 1.25rem;
}

.bio-text strong {
  color: #fcbc0d;
  font-weight: 600;
}

/* Expertise Section */
.expertise-section {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2.5rem;
  backdrop-filter: blur(10px);
}

.expertise-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  margin: 0 0 1.5rem 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.expertise-title svg {
  color: #fcbc0d;
}

.expertise-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 1rem;
}

.expertise-list li {
  display: flex;
  align-items: start;
  gap: 12px;
  color: #cbd5e1;
  font-size: 0.95rem;
  line-height: 1.6;
  transition: transform 0.2s ease, color 0.2s ease;
}

.expertise-list li:hover {
  transform: translateX(8px);
  color: white;
}

.bullet-icon {
  color: #fcbc0d;
  font-weight: 700;
  font-size: 1.2rem;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.expertise-list li:hover .bullet-icon {
  transform: translateX(4px);
}

/* CTA Section */
.cta-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.btn-primary {
  background: linear-gradient(135deg, #fcbc0d 0%, #f59e0b 100%);
  color: #0a1628;
  padding: 14px 32px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 700;
  font-size: 1rem;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 30px rgba(252, 188, 13, 0.3);
  letter-spacing: 0.5px;
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(252, 188, 13, 0.5);
}

.btn-primary svg {
  transition: transform 0.3s ease;
}

.btn-primary:hover svg {
  transform: translateX(4px);
}

.btn-linkedin {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 14px 28px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
}

.btn-linkedin:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-3px);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .ceo-content-grid {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .ceo-image-column {
    max-width: 400px;
    margin: 0 auto;
  }

  .ceo-heading {
    font-size: 2.5rem;
  }
}

@media (max-width: 768px) {
  .premium-ceo-section {
    padding: 4rem 1.5rem;
  }

  .ceo-heading {
    font-size: 2rem;
  }

  .ceo-subtitle {
    font-size: 1.1rem;
  }

  .expertise-section {
    padding: 1.5rem;
  }

  .cta-section {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-primary,
  .btn-linkedin {
    justify-content: center;
    width: 100%;
  }
}
</style>
